import { Injectable } from '@angular/core';
import { AppConfig } from '../../models/appConfig.model';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PlatformLocation } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private configuration: AppConfig;

  constructor(private http: HttpClient,location:PlatformLocation) {
    // Initialize with environment defaults
    this.configuration = {
      baseUrl: environment.baseUrl,
      avenueUrl: environment.avenueUrl,
      razorPayKey: environment.razorPayKey,
      razorpayUrl: 'https://checkout.razorpay.com/v1/checkout.js',
      showGoogleMapAddress: environment.showGoogleMapAddress
    };
    
    // Load configuration from sys-config.json
    this.loadSysConfig(location).subscribe();
  }

   loadSysConfig(location:PlatformLocation): Observable<AppConfig> {
    const baseHref=location.getBaseHrefFromDOM();
    return this.http.get<AppConfig>(`${baseHref}assets/sys-config.json`)
      .pipe(
        catchError(error => {
          console.warn('Failed to load sys-config.json, using environment defaults:', error);
          return of(null);
        }),
        map(config => {
          if (config) {
            this.configuration = {
              ...this.configuration,
              ...config
            };
          }
          return this.configuration;
        })
      );
  }

  readConfig(): AppConfig {
    return this.configuration;
  }
}
